import { SITE_TEMPLATES } from "@/lib/siteTemplates";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function TemplateGallery({ open, onClose, onPick }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#141414] border-white/10 text-white max-w-3xl" data-testid="template-gallery">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Scegli un modello di partenza</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-h-[70vh] overflow-y-auto p-1">
          {SITE_TEMPLATES.map((t) => (
            <button
              key={t.id}
              onClick={() => onPick(t)}
              className="group text-left border border-white/10 rounded-xl overflow-hidden hover:border-primary/50 transition-all"
              data-testid={`template-${t.id}`}
            >
              <div className="h-40 bg-white overflow-hidden relative">
                <iframe
                  title={t.id}
                  srcDoc={t.html}
                  className="w-[200%] h-[200%] origin-top-left pointer-events-none border-0"
                  style={{ transform: "scale(0.5)" }}
                  scrolling="no"
                />
                <div className="absolute inset-0" />
              </div>
              <div className="p-4 border-t border-white/10">
                <div className="flex items-center gap-2">
                  <span className="w-3 h-3 rounded-full" style={{ background: t.accent }} />
                  <h3 className="font-display font-semibold">{t.name}</h3>
                </div>
                <p className="text-sm text-muted-foreground mt-1">{t.desc}</p>
              </div>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
